<template>
  <div>
    <v-text-field :label="label" v-model="value" :rules="enhancedRules" filled :disabled="disabled" />
    <img v-if="previewType === 'image'" :src="value" height="240" alt="preview" />
    <video v-else-if="previewType === 'video'" height="240" controls>
      <source :src="value" :type="mediaType" />
    </video>
    <audio v-else-if="previewType === 'audio'" controls>
      <source :src="value" :type="mediaType" />
    </audio>
  </div>
</template>

<script>
import fieldMixin from '@/mixins/LeanField';

export default {
  name: 'LeanExternalMedia',
  data: () => {
    return {
      mediaType: null,
      enhancedRules: []
    };
  },
  mixins: [fieldMixin],
  computed: {
    previewType: {
      get() {
        if (this.mediaType && this.mediaType.startsWith('image/')) {
          return 'image';
        } else if (this.mediaType && this.mediaType.startsWith('video/')) {
          return 'video';
        } else if (this.mediaType && this.mediaType.startsWith('audio/')) {
          return 'audio';
        }
        return null;
      }
    }
  },
  methods: {
    isValidUrl(string) {
      let url;

      try {
        url = new URL(string);
      } catch (err) {
        return false;
      }

      return url.protocol === 'http:' || url.protocol === 'https:';
    },
    async updateMediaType(url) {
      try {
        const response = await fetch(url, {
          method: 'HEAD'
        });
        this.mediaType = response.headers.get('content-type');
      } catch (err) {
        console.error(err);
      }
    },
    setRules() {
      const schemaValidations = this.config.validations;
      const mimeTypeRule = schemaValidations.filter((rule) => rule.type === 'mime-type').pop();
      if (mimeTypeRule) {
        if (mimeTypeRule['one-of'] && mimeTypeRule['one-of'].includes(this.mediaType)) {
          this.enhancedRules = this.validationRules;
        } else if (mimeTypeRule['one-of']) {
          const mimeTypeValidation = () => this.$t('validation.oneOf', { elements: mimeTypeRule['one-of'].join(', ') });
          this.enhancedRules = [...this.validationRules, mimeTypeValidation];
        }
      }
    }
  },
  watch: {
    value: {
      async handler(newVal) {
        this.mediaType = null;
        if (this.isValidUrl(newVal)) {
          await this.updateMediaType(newVal);
          this.setRules();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.enhancedRules = this.validationRules;
  }
};
</script>
